import PageFrame from './PageFrame';

export default PageFrame;
